import { EventType } from "../../enums";

export class EventData {
  type: EventType;
  cipherId: string;
  date: string;
  organizationId: string;
}
